/** Minimal JWT payload inspection (no signature verification — client-side hints only). */

export interface JwtPayload {
  sub?: string
  account_id?: string
  workspace_id?: string
  scope?: string
  exp?: number
  name?: string
  email?: string
  [claim: string]: unknown
}

export function decodeJwtPayload(token: string): JwtPayload | null {
  const parts = token.split('.')
  if (parts.length !== 3) return null
  try {
    const json = Buffer.from(parts[1].replace(/-/g, '+').replace(/_/g, '/'), 'base64').toString('utf8')
    return JSON.parse(json) as JwtPayload
  } catch {
    return null
  }
}

/** True when the token has an `exp` within `skewSeconds` of now (or already past). */
export function isExpired(token: string, skewSeconds = 60): boolean {
  const payload = decodeJwtPayload(token)
  if (!payload?.exp) return false
  return payload.exp * 1000 <= Date.now() + skewSeconds * 1000
}
